import React, { useEffect } from 'react';
import { useGlobalState } from '../GlobalState';
import { useGetUserQuery } from '../../../user_profile/userProfileSlice';
import { useHistory } from 'react-router-dom';
import LoadingSpinner from '../../../common/LoadingSpinner';
import BookingSuccessScreen from './components/BookingSuccessScreen';

function UserBookingSuccessPage({ fisheryPublicId }) {
  const history = useHistory();
  const [isInsideWidget] = useGlobalState('isInsideWidget');

  const [paymentSuccessRedirect] = useGlobalState('paymentSuccessRedirect');

  const { data: accountDetails } = useGetUserQuery();

  const [bookingId] = useGlobalState('bookingId');
  const [bookingUserId] = useGlobalState('bookingUserId');

  const userId = bookingUserId ?? accountDetails?.id;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (paymentSuccessRedirect) {
      window.location.href =
        paymentSuccessRedirect + `&widget=${isInsideWidget}`;
    }
  }, [history, isInsideWidget, paymentSuccessRedirect]);

  if (paymentSuccessRedirect) {
    return (
      <div className='grid-center txt-center pd-20' style={{ height: 500 }}>
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <BookingSuccessScreen
      fisheryPublicId={fisheryPublicId}
      bookingId={bookingId?.public_id}
      userId={userId}
      isInsideWidget={isInsideWidget}
    />
  );
}

export default UserBookingSuccessPage;
